<div class="spb-holder">
  @if (helper.canAdminClassic()) {
    <div class="statistics">
      <spb-statistics/>
    </div>

    <div class="menu-holder">
      <button (click)="viewType = 'contact'" matButton="outlined">
        Kontakt
      </button>
      <button (click)="viewType = 'list'" matButton="outlined">
        Lista
      </button>
    </div>
  }
  <spb-promise-list [view]="viewType"/>
</div>